import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "translation_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m11.9 22 4.55-12h2.1l4.55 12H21l-1.075-3.05h-4.85L14 22h-2.1ZM4 19l-1.4-1.4 5.05-5.05a11.562 11.562 0 0 1-1.588-2C5.588 9.8 5.15 8.95 4.75 8h2.1c.333.65.667 1.217 1 1.7.333.483.733.967 1.2 1.45.55-.55 1.12-1.32 1.712-2.313C11.354 7.847 11.8 6.9 12.1 6H1V4h7V2h2v2h7v2h-2.9c-.35 1.2-.875 2.433-1.575 3.7-.7 1.267-1.392 2.233-2.075 2.9l2.4 2.45-.75 2.05-3.05-3.125L4 19Zm11.7-1.8h3.6l-1.8-5.1-1.8 5.1Z"
    }, null, -1)
  ]))]))
}
export default { render: render }